module.exports = __webpack_public_path__ + "img/mozgo_transparent.a207ceb7.png";